module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfCBc4AMP6lbBP.e8c6f3a3.woff2";